import styled from "styled-components";

export const LeaderboardPreviewStyled = styled.div`
  .header_row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 12px;
    flex-wrap: wrap;
  }

  .label_th {
    font-family: ${({ theme }) => theme.FONT.STYLE.SEMIBOLD};
    font-size: ${({ theme }) => theme.FONT.SIZE.S16};
    color: ${({ theme }) => theme.COLORS.GRAY_23};
  }

  .label_en {
    font-family: ${({ theme }) => theme.FONT.STYLE.MEDIUM};
    font-size: ${({ theme }) => theme.FONT.SIZE.S12};
    color: ${({ theme }) => theme.COLORS.GRAY_26};
  }

  .detail_link {
    display: flex;
    align-items: center;
    border: none;
    background: transparent;
    padding: 0;
    cursor: ${({ isDisabled }) => isDisabled ? 'not-allowed' : 'pointer'};
    font-family: ${({ theme }) => theme.FONT.STYLE.SEMIBOLD};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    color: ${({ theme, isDisabled }) => isDisabled ? theme.COLORS.GRAY_29 : theme.COLORS.PURPLE_1};
    text-decoration: underline;
    flex-shrink: 0;

    &:hover {
      opacity: 0.85;
    }
  }
  .image_container {
    text-align: center;
  }
`;
